import {Component, Input, OnInit} from '@angular/core';

@Component({
  selector: 'app-loader',
  templateUrl: './loader.component.html',
  styleUrls: ['./loader.component.css']
})
export class LoaderComponent implements OnInit {
  @Input() status: number = 0;
  txCount: number = 0;

  constructor() { }

  ngOnInit(): void {
  }

  GetLoadVisible():boolean
  {
    if(this.status == -1)
      return true;
    if(this.status == 1)
      return false;
    return true;
  }

}
